import { InputText } from "primereact/inputtext";
import { FC } from "react";

interface PInputField {
    label: string;
    id: string;
    value: string;
    placeholder: string;
    error?: string;
    onBlur?: () => void;
    onChange: (value: string) => void;
}

const InputField: FC<PInputField> = ({ label, id, value, placeholder, error, onBlur, onChange }) => (
    <div className="personal-settings-input-container">
        <label className="input_label" htmlFor={id}>
            {label}
        </label>
        <InputText
            id={id}
            value={value}
            placeholder={placeholder}
            onBlur={onBlur}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
        />
        {error && <p className="error_message">{error}</p>}
    </div>
);

export default InputField